import { Helmet } from 'react-helmet';

import { Container, Section } from '../components/Base';
import { getTitle } from '../utils/document';

import AccessibilityPageMdx from './AccessibilityPage.mdx';

const AccessibilityPage = () => {
  return (
    <Section className="privacy">
      <Helmet>
        <title>{getTitle('Accessibility')}</title>
      </Helmet>
      <Container>
        <div className="gfp-row">
          <div className="col-8 offset-2">
            <h1>Accessibility</h1>
            <div className="prose legal-text">
              <AccessibilityPageMdx />
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default AccessibilityPage;
